<template>
  <div class="operate_box">
    <van-button type="default" size="small" round text="说两句..." class="comment_btn" @click="onCommentClick($event)"></van-button>
    <div class="operate_right">
      <span class="praise">
        <Icon iconClass="praise" @click="cancelPraiseHandler" v-if="isLiked == true" />
        <Icon iconClass="praise-o" @click="praiseHandler" v-else />
      </span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { addScore } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "Operate",
  props: {
    params: {
      type: Object,
      default: null,
    },
    contentTitle: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
      default: "",
    },
  },
  computed: {
    ...mapState("app", ["userInfo", "deviceId"]),
  },
  data() {
    return {
      isTop: true, // 默认显示顶部
      isLiked: false, // 是否已点赞
    };
  },
  methods: {
    /* 获取点赞状态 */
    getThumbsUpStatus() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .queryThumbsUpStatus(params)
        .then((res) => {
          if (res.suc == 1) {
            if (res.data.userLikes == 1) {
              _this.isLiked = true;
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 评论 */
    onCommentClick() {
      if (!!this.userInfo) {
        this.$emit("showCommentForm", true);
      } else {
        this.$router.push("/login");
      }
    },
    /* 点赞 */
    praiseHandler() {
      var _this = this;

      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }

      commApi
        .giveThumbsUp(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.isLiked = true;
            _this.addScore(); // 增加积分
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 取消点赞 */
    cancelPraiseHandler() {
      var _this = this;

      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .cancelThumbsUp(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.isLiked = false;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "dz", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
        description: "点赞", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
        contentType: this.params.contentType, // 非必传，稿件的type
        contentId: this.params.liveroomId, // 非必传，稿件的id
        contentName: this.contentTitle, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
  },
  created() {
    this.getThumbsUpStatus(); //获取点赞状态
  },
};
</script>
<style scoped lang="scss">
.operate_box {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  width: 100%;
  height: 40px;
  padding: 5px 15px;
  background-color: #fff;
  border-top: 1px solid #ebedf0;
  .comment_btn {
    width: 100%;
    height: 30px;
    background: #ebedf0;
    border: none;
    font-size: 14px;
    color: #b3b3b3;
    .van-button__content {
      padding-left: 10px;
      padding-right: 10px;
      -webkit-justify-content: normal;
      justify-content: normal;
      text-align: left;
    }
  }
  .operate_right {
    flex: none;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    text-align: right;
    .tj-svg-icon {
      color: #bebebe;
      vertical-align: middle;
      &.tj-icon-praise-o {
        font-size: 20px;
      }
      &.tj-icon-praise {
        font-size: 20px;
        color: #318bff;
      }
    }
    .praise {
      margin-left: 10px;
    }
  }
}
</style>